const exportedObject = {
  validarProcedimientoData: {},
  validarProcedimientoLoading: false,
  validarProcedimientoError: null,

  eliminarProcedimientoData: {},
  eliminarProcedimientoLoading: false,
  eliminarProcedimientoError: null,
};

export default exportedObject;